import { useQuery } from '@tanstack/react-query';
import { useDispatch } from 'react-redux';
import { useMemo } from 'react';
import orgApi from '../../services/orgApi';
import {
  HRIS_DISABLED_TOOLTIP_TEXT,
  HrisIntegrationStatus
} from '../../utils/constants';
import userApi from '../../services/userApi';
import { saveUsersList } from '../Invite/store/actions';
import { shouldInviteBeDisabled } from './utils';

export const useHrisIntegrationStatus = enabled =>
  useQuery({
    queryKey: ['hrisIntegrationStatus'],
    queryFn: async () => {
      const { data } = await orgApi.getHrisIntegrationStatus();
      if (data && data.sync_status === HrisIntegrationStatus.active) {
        const epochToDateObject = new Date(data.last_sync_time);
        return {
          status: HrisIntegrationStatus.active,
          lastSyncTime: epochToDateObject,
          hrisProvider: data.hris_provider
        };
      }
      return { status: HrisIntegrationStatus.inactive };
    },
    enabled,
    onError: () => ({ status: HrisIntegrationStatus.inactive })
  });

export const useFetchUsersList = burstCache => {
  const dispatch = useDispatch();

  useQuery({
    queryKey: ['usersList', burstCache],
    queryFn: async () => {
      const { data } = await userApi.getUserList({ burstCache });
      dispatch(saveUsersList(data, true));
      return data;
    }
  });
};

export const useHrisIntegrationInfo = enabled => {
  const { data: hrisData } = useHrisIntegrationStatus(enabled);

  const inviteDisabledInfo = useMemo(() => {
    const result = {
      disabled: false,
      reason: ''
    };
    if (!hrisData) return result;
    const disableInvite = shouldInviteBeDisabled(hrisData?.status);
    if (disableInvite) {
      result.disabled = true;
      result.reason = HRIS_DISABLED_TOOLTIP_TEXT;
    }
    return result;
  }, [hrisData]);

  return {
    hrisData,
    inviteDisabledInfo
  };
};
